"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Insurance = void 0;
var Insurance_1 = require("./Insurance");
Object.defineProperty(exports, "Insurance", { enumerable: true, get: function () { return Insurance_1.Insurance; } });
//# sourceMappingURL=index.js.map